<div #editorRoot class="expressao-editor" tabindex="0" (keydown)="onKeyDown($event)">

    <div class="tokens-display"
        [class.empty]="tokens.length === 0"
        [class.has-selection]="selectedSet.size > 0">

        <div class="tokens-flow"
            cdkDropList [cdkDropListData]="tokens" cdkDropListOrientation="mixed"
            [cdkDropListSortPredicate]="podeOrdenarToken"
            (cdkDropListDropped)="onDrop($event)"
            (click)="onBackgroundClick($event)">

            @if (tokens.length === 0) {
            <span class="tokens-placeholder">Clique nas variáveis e operadores abaixo para construir a expressão...</span>
            }

            @for (token of tokens; track token; let i = $index) {
            @if (!arrastandoToken && !editing && cursorIndex === i) { <span class="cursor-indicator" aria-hidden="true"></span> }

            <span #tokenElement class="token status-badge {{ tokenClass(i) }}"
                [class.token-selected]="isSelected(i)"
                [class.token-error]="isTokenComErro(i)"
                [class.token-drag-companion]="isTokenOcultoDuranteArraste(i)"
                [matTooltip]="mensagensErroToken(i)"
                [matTooltipDisabled]="!isTokenComErro(i)"
                matTooltipPosition="above"
                #erroTooltip="matTooltip"
                [class.badge-variavel]="token.tipo === FormulaTokenTipoEnum.Variavel"
                cdkDrag [cdkDragDisabled]="token === editing"
                (cdkDragStarted)="onDragStarted(i, $event)"
                (cdkDragEnded)="onDragEnded($event)"
                (click)="onTokenClick(i, $event); exibirTooltipErro(i, erroTooltip)"
                (dblclick)="onTokenDblClick(token, $event)"
                [attr.data-chave]="variavelChaveToken(token)">
                <span class="cursor-indicator cursor-indicator--drag" *cdkDragPlaceholder aria-hidden="true"></span>
                <div class="drag-preview" *cdkDragPreview>
                    @if (blocoPreviewArraste(i); as bloco) {
                    <span class="drag-token-preview status-badge"
                        [ngClass]="tokenClass(bloco.start)"
                        [attr.aria-label]="bloco.nome + ' em arraste'">
                        {{ tokens[bloco.start].display }}
                        <span class="material-symbols-outlined" aria-hidden="true">stacks</span>
                    </span>
                    } @else {
                    <span class="drag-token-preview status-badge" [ngClass]="tokenClass(i)">{{ token.display }}</span>
                    }
                </div>
                @if (token === editing) {
                <input #constInput class="token-input" type="text" inputmode="decimal"
                    [currencyMask]="mascaraConstanteEmEdicao" [formControl]="editControl"
                    [placeholder]="tipoConstanteSelecionada === TipoConstanteNumericaEnum.Inteiro ? '0' : '0,00'"
                    (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
                    (keydown)="onConstanteKeyDown($event)" (paste)="onConstantePaste($event)"
                    (keydown.enter)="commitEdit()" (keydown.escape)="commitEdit()" (blur)="commitEdit()">
                } @else if (token.tipo === FormulaTokenTipoEnum.Variavel) {
                @if (isParametro(token)) {
                <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span>
                }
                @if (possuiFormulaAplicavel(token)) {
                <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span>
                }
                <span class="variavel-badge-descricao">{{ variavelNome(token) }}</span>
                <span class="variavel-badge-nome">{{ '{' + variavelNomeVariavel(token) + '}' }}</span>
                } @else {
                {{ token.display }}
                }
            </span>
            }
            @if (!arrastandoToken && !editing && cursorIndex === tokens.length) { <span class="cursor-indicator" aria-hidden="true"></span> }
        </div>

        <div class="editor-footer">
            <div class="editor-footer-principal">
                <div class="editor-footer-contexto">
                    @if (blocoSomaSelecionado) {
                    <div class="parametros-control" aria-label="Parâmetros da função soma">
                        <button mat-icon-button type="button" [disabled]="quantidadeParametrosSoma <= 1"
                            (click)="$event.stopPropagation(); removerParametroSoma()" title="Remover último parâmetro">
                            <mat-icon>remove</mat-icon>
                        </button>
                        <span>{{ quantidadeParametrosSoma }} parâmetro(s)</span>
                        <button mat-icon-button type="button"
                            (click)="$event.stopPropagation(); adicionarParametroSoma()" title="Adicionar parâmetro">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    }

                    @if (tokenNumeroSelecionado) {
                    <mat-button-toggle-group class="btn-toggle-group"
                        [value]="tipoConstanteSelecionada"
                        (change)="alterarTipoConstante($event.value)"
                        aria-label="Tipo da constante numérica">
                        <mat-button-toggle [value]="TipoConstanteNumericaEnum.Decimal">Decimal</mat-button-toggle>
                        <mat-button-toggle [value]="TipoConstanteNumericaEnum.Inteiro">Inteiro</mat-button-toggle>
                    </mat-button-toggle-group>
                    }
                </div>

                <div class="editor-footer-actions">
                    @if (tokenNumeroSelecionado) {
                    <button mat-icon-button class="floating-btn btn-editar" type="button"
                        (click)="$event.stopPropagation(); editarSelecionado()" title="Editar constante">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>
                    <button mat-icon-button class="floating-btn btn-excluir-sel" type="button"
                        (click)="$event.stopPropagation(); removerConstanteAtiva()" title="Remover constante">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                    }
                    @if (selectedSet.size > 0 && !tokenNumeroSelecionado) {
                    <button mat-icon-button class="floating-btn btn-excluir-sel" type="button"
                        (click)="$event.stopPropagation(); removerSelecionados()" title="Excluir selecionados (Delete)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                    }
                    @if (temConteudo) {
                    <button mat-icon-button class="floating-btn btn-limpar" type="button"
                        (click)="$event.stopPropagation(); limpar()" title="Limpar fórmula">
                        <mat-icon class="material-symbols-outlined">cleaning_services</mat-icon>
                    </button>
                    }
                </div>
            </div>

            @if (mensagemErroTokenAtivo) {
            <div class="editor-footer-erro">
                <span class="token-error-label">{{ mensagemErroTokenAtivo }}</span>
            </div>
            }
        </div>
    </div>

</div>
